import { render, staticRenderFns } from "./transferDrawer.vue?vue&type=template&id=478354f0&scoped=true&"
import script from "./transferDrawer.vue?vue&type=script&lang=ts&"
export * from "./transferDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./transferDrawer.vue?vue&type=style&index=0&id=478354f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478354f0",
  null
  
)

export default component.exports